import { ModalType } from '@/components/modal/form-filling-modals/pdf-loading-modal.enums';
import { type FormViewType } from '@/components/modal/form-filling-modals/view-form-modal/view-form-modal.types';
import type { ExtractedField, PageDimensionsByPage } from '@heidi/templates/contracts';
import { type TemplateResponse } from '@heidi/templates/contracts';
import { DEFAULT_PAGE_DIMENSIONS_BY_PAGE } from '@heidi/templates/data';
import { atom } from 'jotai';

type FormFillingData = {
  file: File;
  url: string;
};

export const chooseTemplateTypeModalOpenAtom = atom<boolean>(false);
export const formFillingUploadModalOpenAtom = atom<boolean>(false);

export const formViewModalOpenAtom = atom<boolean>(false);
export const formTemplateToEditAtom = atom<TemplateResponse | null>(null);
export const formViewTypeAtom = atom<FormViewType | null>(null);
export const formDraftTitleAtom = atom<string>('');

export const formFillingDataAtom = atom<FormFillingData | null>(null);

export const pdfLoadingModalTypeAtom = atom<ModalType>(ModalType.PREPARING);
export const pdfLoadingModalOpenAtom = atom<boolean>(false);

export const newlyCreatedTemplateAtom = atom<{ id: string; name: string } | null>(null);

export const formFieldsToSaveAtom = atom<ExtractedField[]>([]);
export const formFieldsEditedAtom = atom<boolean>(false);
export const formFieldsPageDimensionsAtom = atom<PageDimensionsByPage>(
  DEFAULT_PAGE_DIMENSIONS_BY_PAGE
);
export const resetFormFieldSaveStateAtom = atom(null, (_get, set) => {
  set(formFieldsToSaveAtom, []);
  set(formFieldsEditedAtom, false);
  set(formFieldsPageDimensionsAtom, DEFAULT_PAGE_DIMENSIONS_BY_PAGE);
});

/**
 * XML form review step (XML-MVP). XML never enters `/scribe/form-editor` — the
 * editor is a PDF canvas and has no page to lay fields out on — so the upload
 * modal hands the file to its own review modal instead.
 */
export const xmlFormReviewModalOpenAtom = atom<boolean>(false);
export const xmlFormReviewFileAtom = atom<File | null>(null);
export const xmlFormEditModalOpenAtom = atom<boolean>(false);
export const xmlFormEditTemplateAtom = atom<TemplateResponse | null>(null);

/**
 * JSON form review and edit. Same split as XML: the upload modal hands the
 * file to review, and existing templates edit here rather than on the PDF
 * canvas. Both stay closed while `release-growth-enable-json-form` is off.
 */
export const jsonFormReviewModalOpenAtom = atom<boolean>(false);
export const jsonFormReviewFileAtom = atom<File | null>(null);
export const jsonFormEditModalOpenAtom = atom<boolean>(false);
export const jsonFormEditTemplateAtom = atom<TemplateResponse | null>(null);

/** Route to return to after leaving `/scribe/form-editor` (set before navigating in). */
export const formEditorReturnPathAtom = atom<string | null>(null);
